import customSelectStyle from 'assets/jss/material-dashboard-pro-react/customSelectStyle'

const customisableSelectStyle = {
  ...customSelectStyle
}

export default customisableSelectStyle
